import { useRef } from 'react';
import { ReactElement, useCallback } from 'react';

import { FormHandles } from '@unform/core';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { GoBackButton, Button } from '~/components';
import { useLoading } from '~/hooks/loading';
import { ISymbology } from '~/models/Symbology';
import SymbologyService from '~/services/Simbology';
import { handleYupValidationError } from '~/utils';
import { SymbologySchema } from '~/utils/schemas/SymbologySchema';

import EditSymbologyForm from '../EditSymbologyForm';

import * as S from './styles';

function SymbologyCadaster(): ReactElement {
  const { setLoading } = useLoading();

  const formRef = useRef<FormHandles>(null);
  const router = useHistory();

  const handleCancel = useCallback(() => {
    router.goBack();
  }, [router]);

  const handleSymbologyCadasterSubmit = useCallback(
    async (data: ISymbology) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        await SymbologySchema.validate(data, {
          abortEarly: false,
        });

        const result = await SymbologyService.createSymbology(data);
        if (result.status === 200) {
          toast.success('Simbologia cadastrada com sucesso!');
          router.goBack();
        } else {
          toast.error('Ocorreu um problema ao cadastrar a simbologia!');
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleYupValidationError(formRef, error);
      }
    },
    [router],
  );

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Cadastrar Simbologia</S.Title>
        </S.Header>
        <EditSymbologyForm
          formName="symbology-cadaster"
          formRef={formRef}
          handleSubmit={handleSymbologyCadasterSubmit}
        />
        <S.Footer>
          <Button
            form="symbology-cadaster"
            type="submit"
            textContent="Salvar"
            variant="black"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
          <Button
            type="button"
            onClick={handleCancel}
            textContent="Cancelar"
            variant="red"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
        </S.Footer>
      </S.Container>
    </>
  );
}

export default SymbologyCadaster;
